import { post } from "../../xhr/api";

export const store_dispute_request=(data)=> {
    return post('api/tax-dispute/request',{},data,true);
}